var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 8 } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                attrs: {
                  paramsData: _vm.upData,
                  filesname: "item_file",
                  Url: "/data/uploadBagItemTypeFile",
                  title: _vm.$t("batchUpload")
                },
                on: {
                  change: function($event) {
                    return _vm.Refresh(1)
                  }
                }
              }),
              _c(
                "el-button",
                {
                  staticClass: "marginL",
                  attrs: { type: "primary" },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "marginL",
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: _vm.$t("idLabel"), width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "type_name", label: _vm.$t("typeName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "type_id", label: _vm.$t("typeIdLabel") }
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.currentPage,
          total: _vm.tableCopyTableList.length,
          "page-size": _vm.pageSize
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }